import { createSlice } from "@reduxjs/toolkit";

const initialState = {

    selectedShipId: null,
};


const shipSlice = createSlice({
    name: "ship",
    initialState,
    reducers: {
          setSelectedShipId(state, action) {
      state.selectedShipId = action.payload;
    },
    }
})

export const {
 setSelectedShipId
} = shipSlice.actions;

export default shipSlice.reducer;